"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "11", height: "11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.285 5.142l4-4L9.142 0l-4 4-4-4L0 1.143l4 4-4 3.999 1.143 1.143 4-4 4 4 1.142-1.143-4-4z", fill: "#1F1F1F" }))); };
exports.default = Component;
//# sourceMappingURL=No.js.map